var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Actions from '../../actions';
var initialState = {
    foldedOpen: false,
    mobileOpen: false
};
var navbar = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case Actions.TOGGLE_FOLDED_NAVBAR: {
            return __assign(__assign({}, state), { foldedOpen: !state.foldedOpen });
        }
        case Actions.OPEN_FOLDED_NAVBAR: {
            return __assign(__assign({}, state), { foldedOpen: true });
        }
        case Actions.CLOSE_FOLDED_NAVBAR: {
            return __assign(__assign({}, state), { foldedOpen: false });
        }
        case Actions.TOGGLE_MOBILE_NAVBAR: {
            return __assign(__assign({}, state), { mobileOpen: !state.mobileOpen });
        }
        case Actions.OPEN_MOBILE_NAVBAR: {
            return __assign(__assign({}, state), { mobileOpen: true });
        }
        case Actions.CLOSE_MOBILE_NAVBAR: {
            return __assign(__assign({}, state), { mobileOpen: false });
        }
        default: {
            return state;
        }
    }
};
export default navbar;
